import type { PropsWithChildren } from 'react'

import ChevronDownIcon from '../../../assets/images/icons/chevron-down.svg?react'
import {
  ReportsIcon,
  ReportsSmallIcon,
} from '../../../components/icons/navigation'
import { useMeQuery } from '../../../store/api'

export default function ReportsLink({
  children,
  small = false,
  mobile = false,
}: PropsWithChildren<{ small?: boolean; mobile?: boolean }>): JSX.Element {
  const { data } = useMeQuery()

  if (data && !data.has_tracker) {
    if (mobile) {
      return (
        <div className="flex flex-col">
          <div
            className="flex flex-row items-center justify-between px-2 hover:bg-primary-50 rounded-lg py-2"
            data-tooltip-id="reports-menu-tooltip"
            data-tooltip-content="You need to add one product and one url."
            data-tooltip-place="right"
          >
            <div className="flex flex-row items-center flex-1">
              <div className="flex flex-row justify-between w-full">
                <div className="flex flex-row flex-1">
                  <ReportsIcon />
                  <span className="pl-4">Reports</span>
                </div>
                <div className="rounded-full bg-primary-75 text-sm w-6 h-6 relative mr-2">
                  <span className="absolute w-6 h-6 text-xs leading-6 text-center left-0 top-0">
                    0
                  </span>
                </div>
              </div>
            </div>
            <div>
              <ChevronDownIcon />
            </div>
          </div>
        </div>
      )
    }
    if (small) {
      return (
        <div
          className="flex flex-row items-center pb-4 cursor-pointer"
          data-tooltip-id="reports-menu-tooltip"
          data-tooltip-content="You need to add one product and one url."
          data-tooltip-place="right"
        >
          <ReportsSmallIcon />
        </div>
      )
    }
    return (
      <>
        <div className="flex flex-col hover:bg-primary-50 border-0 rounded-md justify-center py-2">
          <div
            className="flex flex-row items-center justify-between cursor-pointer"
            data-tooltip-id="reports-menu-tooltip"
            data-tooltip-content="You need to add one product and one url."
            data-tooltip-place="right"
          >
            <div className="flex flex-row items-center w-full">
              <div className="flex flex-row justify-between w-full">
                <div className="flex flex-row flex-1">
                  <ReportsIcon />
                  <span className="pl-4">Reports</span>
                </div>
                <div className="rounded-full bg-primary-75 text-sm w-6 h-6 relative mr-2">
                  <span className="absolute w-6 h-6 text-xs leading-6 text-center left-0 top-0">
                    0
                  </span>
                </div>
              </div>
            </div>
            <ChevronDownIcon />
          </div>
        </div>
      </>
    )
  }

  return <>{children}</>
}
